import React, { FC, ReactNode } from 'react';
import { Box, Card, CardHeader, Heading, Link, Text } from '@amzn/storm-ui';

interface BenefitItemProps {
  icon: ReactNode;
  heading: string;
  description: string;
}

export const BenefitItem: FC<BenefitItemProps> = ({
  icon,
  heading,
  description,
}) => (
  <Box style={{ flex: 1 }}>
    {icon}
    <Heading renderAs="h6" typeface="display">
      {heading}
    </Heading>
    <Text>{description}</Text>
  </Box>
);

interface ActionCardProps {
  heading: string;
  description: string;
  linkText: string;
  href: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const ActionCard: FC<ActionCardProps> = ({
  heading,
  description,
  linkText,
  href,
  onClick,
}) => (
  <Box style={{ flex: 1 }}>
    <Card padding="medium">
      <CardHeader>
        <Heading renderAs="h4" typeface="display">
          {heading}
        </Heading>
        <Text color="secondary">{description}</Text>
      </CardHeader>
      <Link href={href} onClick={onClick}>
        {linkText}
      </Link>
    </Card>
  </Box>
);
